// 数据管理模块页面级国际化
export default {
  // ─── 知识库通用 ────────────────────────────────────────────────────────────
  'data.dataset.status.enabled': '启用中',
  'data.dataset.status.disabled': '已禁用',
  'data.dataset.status.enable': '启用',
  'data.dataset.status.disable': '禁用',
  'data.dataset.status.notEnabled': '未启用',
  'data.dataset.status.alreadyEnabled': '已启用',

  // ─── 操作反馈 ──────────────────────────────────────────────────────────────
  'data.dataset.message.opSuccess': '操作成功',
  'data.dataset.message.opFail': '操作失败',
  'data.dataset.message.fetchListFail': '获取知识库列表失败',
  'data.dataset.message.fetchDetailFail': '获取知识库详情失败',
  'data.dataset.message.createSuccess': '创建成功',
  'data.dataset.message.createFail': '创建失败',
  'data.dataset.message.addFail': '添加失败请重试！',
  'data.dataset.message.updateSuccess': '更新成功',
  'data.dataset.message.updateFail': '更新失败',

  // ─── 列表页 ────────────────────────────────────────────────────────────────
  'data.dataset.list.title': '知识库管理',
  'data.dataset.list.new': '新建',
  'data.dataset.list.col.cover': '封面',
  'data.dataset.list.col.name': '名称',
  'data.dataset.list.col.desc': '描述',
  'data.dataset.list.col.model': '嵌入模型',
  'data.dataset.list.col.docCount': '文档数量',
  'data.dataset.list.col.role': '角色',
  'data.dataset.list.col.company': '公司',
  'data.dataset.list.col.updateTime': '更新时间',
  'data.dataset.list.col.action': '操作',
  'data.dataset.list.action.edit': '编辑',
  'data.dataset.list.action.config': '配置',
  'data.dataset.list.tag.more': '更多',
  'data.dataset.list.tag.collapse': '收起',
  'data.dataset.list.total': '总数',

  // ─── 搜索表单 ──────────────────────────────────────────────────────────────
  'data.dataset.search.name.label': '名称',
  'data.dataset.search.name.placeholder': '请输入知识库名称',
  'data.dataset.search.company.label': '公司',
  'data.dataset.search.company.placeholder': '请选择公司',
  'data.dataset.search.role.label': '角色',
  'data.dataset.search.role.placeholder': '请选择角色',
  'data.dataset.search.status.label': '状态',
  'data.dataset.search.status.placeholder': '请选择状态',

  // ─── 卡片组件 ──────────────────────────────────────────────────────────────
  'data.dataset.card.docCount': '文档数:',

  // ─── 创建/编辑表单 ─────────────────────────────────────────────────────────
  'data.dataset.create.title': '创建知识库',
  'data.dataset.edit.title': '编辑知识库',

  'data.dataset.form.name.label': '名称',
  'data.dataset.form.name.placeholder': '请输入知识库名称',
  'data.dataset.form.name.required': '请输入知识库名称',
  'data.dataset.form.cover.label': '封面',
  'data.dataset.form.icon.label': '应用图标',
  'data.dataset.form.desc.label': '描述',
  'data.dataset.form.desc.placeholder': '请输入知识库描述',
  'data.dataset.form.sort.label': '排序',
  'data.dataset.form.sort.placeholder': '请输入排序号',
  'data.dataset.form.sort.required': '请输入排序号',
  'data.dataset.form.status.label': '状态',
  'data.dataset.form.status.placeholder': '请选择状态',
  'data.dataset.form.status.required': '请选择状态',
  'data.dataset.form.file-company.label': '文件指向公司',
  'data.dataset.form.file-company.placeholder': '请选择文件指向公司',
  'data.dataset.form.company.label': '所属公司',
  'data.dataset.form.company.placeholder': '请选择所属公司',
  'data.dataset.form.dept.label': '所属部门',
  'data.dataset.form.dept.placeholder': '请选择所属部门',
  'data.dataset.form.dept.keyword.placeholder': '请输入关键词',
  'data.dataset.form.dept.other': '其他',
  'data.dataset.form.role.label': '所属角色',
  'data.dataset.form.role.placeholder': '请选择所属角色',
  'data.dataset.form.user.label': '所属用户',
  'data.dataset.form.user.placeholder': '请选择所属用户',
};
